module.exports = "/fonts/element-icons.woff?2fad952a20fbbcfd1bf2ebb210dccf7a";